import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  IconButton,
  CircularProgress
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const ScheduleRequestModal = ({ open, handleClose, onSubmit, selectedRecord, loading = false }) => {
  const [publishAt, setPublishAt] = useState("");
  const [note, setNote] = useState("");
  const { t, i18n } = useTranslation();

  const currentLang = i18n.language;

  // Dynamic title
  const albumTitle =
    currentLang === "fr"
      ? selectedRecord?.titleFr
      : selectedRecord?.titleEn;

  const handleSubmit = async () => {
    if (!publishAt || loading) return;

    if (onSubmit) {
      await onSubmit({
        publishAt: new Date(publishAt).toISOString(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        currentTime: new Date().toISOString(),
        note
      });
    }

    handleClose();
    setPublishAt("");
    setNote("");
  };

  const getLocalDateTime = (date) => {
    const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return localDate.toISOString().slice(0, 16);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {t('albums.popup_titles.schedule_request_for',"Schedule Request for")} <strong>{albumTitle}</strong>
        <IconButton onClick={handleClose} sx={{ position: "absolute", right: '16px', top: '20px', padding: '0', color: 'white' }}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent
        dividers 
        sx={{ 
          borderColor: 'rgba(230, 210, 249, 0.1)', 
          padding: '24px 16px',
          '&::-webkit-scrollbar': {
              width: '8px',
          },
          '&::-webkit-scrollbar-track': {
              background: 'rgba(255, 255, 255, 0.05)',
              borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb': {
              background: 'rgba(230, 210, 249, 0.3)',
              borderRadius: '4px',
              '&:hover': {
              background: 'rgba(230, 210, 249, 0.5)',
              },
          },
        }}
      >
        <Stack>
          <TextField
            // label="Publish Date & Time"
            type="datetime-local"
            fullWidth
            value={publishAt}
            onChange={(e) => setPublishAt(e.target.value)}
            InputLabelProps={{ shrink: true }}
            inputProps={{
              min: getLocalDateTime(new Date())
            }}
            sx={{ 
              mb: 2,
              '& .MuiOutlinedInput-input': {
                padding: '12px 20px',
                fontWeight: 400,
                color: '#fff',
              },
              '& input::placeholder': {
                color: 'rgba(255,255,255,0.6)',
                opacity: 1,
              },
              "& input[type='datetime-local']": {
                colorScheme: "dark",
              }
            }}
          />

          {/* <TextField
            multiline
            rows={3}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Add any notes for admin approval..."
            sx={{
              '& .MuiOutlinedInput-input': {
                  padding: '0 10px',
                  fontWeight: '400',
                  color: '#fff',
              },
              '& input::placeholder': {
                  color: 'rgba(255,255,255,0.6)',
                  opacity: 1,
              },
            }}
          /> */}
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: '16px', py: '20px',flexWrap: 'wrap', gap: '6px' }}>
        <Button onClick={handleClose} sx={{ backgroundColor: 'rgba(227, 214, 245, 0.2) !important', border: '1px solid rgba(227, 214, 245, 0.1)', fontSize: '15px', lineHeight: '20px', fontWeight: '400', padding: '11px 20px', minWidth: { xs: '100%', sm: '150px' }, color: 'white', borderRadius: '999px', textTransform: 'capitalize' }}>
          {t('cancel',"Cancel")}
        </Button>
        <Button 
          onClick={handleSubmit} 
          variant="contained"
          disabled={!publishAt || loading}
          sx={{
            py: 1.5,
            borderRadius: '999px',
            fontWeight: '400',
            fontSize: '15px',
            lineHeight: '20px',
            background: 'linear-gradient(90deg, rgba(161, 37, 235, 1) 0%, rgba(253, 86, 201, 1) 100%)',
            textTransform: 'capitalize',
            minWidth: { xs: '100%', sm: '150px' },
            marginLeft: '10px',
          }}
        >
          {loading ? <CircularProgress size={20} sx={{ color: 'white' }} /> : t('albums.actions.send_request',"Send Request")}
        </Button>
      </DialogActions>

    </Dialog>
  );
};

export default ScheduleRequestModal;
